import React from 'react';
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Input,
  Label,
  RadioButtonGroup,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@roger/ui-components';
import { PRESENCE_OPTIONS } from '../../../constants/wounds';
import type { TunnelingState } from '../assessmentFormTypes';

interface TunnelingSectionProps {
  state: TunnelingState;
  onChange: (update: Partial<TunnelingState>) => void;
}

const CLOCK_POSITIONS = Array.from({ length: 12 }, (_, i) => ({
  value: String(i + 1),
  label: String(i + 1),
}));

const TunnelingSection: React.FC<TunnelingSectionProps> = ({
  state,
  onChange,
}) => (
  <AccordionItem value='tunneling' className='border rounded-md px-3'>
    <AccordionTrigger className='text-sm font-medium py-3'>
      Tunneling
    </AccordionTrigger>
    <AccordionContent className='pb-3 space-y-3'>
      <RadioButtonGroup
        options={PRESENCE_OPTIONS.map(o => ({
          value: o.value,
          label: o.label,
        }))}
        value={state.value}
        onValueChange={v =>
          onChange({
            value: v,
            ...(v !== 'yes' && { direction: '', depth: '' }),
            ...(v !== 'not_assessed' && { notAssessedReason: '' }),
          })
        }
      />
      {state.value === 'not_assessed' && (
        <Input
          placeholder='Reason not assessed...'
          value={state.notAssessedReason}
          onChange={e => onChange({ notAssessedReason: e.target.value })}
          inputSize='sm'
        />
      )}
      {state.value === 'yes' && (
        <div className='grid grid-cols-2 gap-3'>
          <div className='space-y-1'>
            <Label className='text-xs'>Direction</Label>
            <Select
              value={state.direction}
              onValueChange={v => onChange({ direction: v })}
            >
              <SelectTrigger selectSize='sm'>
                <SelectValue placeholder="o'clock" />
              </SelectTrigger>
              <SelectContent>
                {CLOCK_POSITIONS.map(p => (
                  <SelectItem key={p.value} value={p.value}>
                    {p.label} o&apos;clock
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className='space-y-1'>
            <Label className='text-xs'>Depth (cm)</Label>
            <Input
              type='number'
              step='0.1'
              min='0'
              value={state.depth}
              onChange={e => onChange({ depth: e.target.value })}
              inputSize='sm'
            />
          </div>
        </div>
      )}
    </AccordionContent>
  </AccordionItem>
);

export default TunnelingSection;
